import React from 'react';
import { Box } from '@mui/material';
import { elliottTokens as t } from './tokens';

// Three bouncing dots shown while Elliott is "generating" the next question.
const TypingDots: React.FC = () => (
  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', height: 22 }}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: t.textTertiary,
          animation: 'addProgTyping 1.2s ease-in-out infinite',
          animationDelay: `${i * 0.18}s`,
          '@keyframes addProgTyping': {
            '0%, 60%, 100%': { transform: 'translateY(0)', opacity: 0.4 },
            '30%': { transform: 'translateY(-4px)', opacity: 1 }
          }
        }}
      />
    ))}
  </Box>
);

export default TypingDots;
